<a [appClub]="club" class="icon">
  <app-avatar [src]="club.icon" [placeholder]="club | initials" class="img-fluid"></app-avatar>
</a>
<div class="ceil-content">
  <div class="ceil-text">
    <div class="ceil-title">
      <a [appClub]="club">{{club.name}}</a>
    </div>
    <div class="ceil-sub-title d-flex flex-wrap">
      <!--      Age Group: {{group.agegroup.name | clearAgeGroup}} • {{group.members}} members-->
      <ng-container *ngIf="club?.body?.name || club?.org?.name; else onlyMembers"
        >{{club?.org?.name ? club?.org?.name : club?.body?.name}}
        <div class="pl-1"> • {{club.members}} members</div></ng-container
      >
      <ng-template #onlyMembers>{{club.members}} members</ng-template>
    </div>
    <div class="ceil-description"> {{club.description | textTruncate: 190}} </div>
    <div class="ceil-explore-link">
      <!--      <a href="" (click)="subscribeToGroup(); false" *ngIf="!group.is_subscriber && !group.is_requested">Join group</a>-->
      <!--      <a href="" (click)="unsubscribeFromGroup(group); false"-->
      <!--        *ngIf="group.is_subscriber ||group.is_requested ">Unsubscribe</a>-->
      <a [appClub]="club">Explore this club</a>
    </div>
  </div>
</div>
